<template>
  <div
    v-loading="loading"
    :element-loading-text="$t('commonInfo.Loading')"
    class="main-frame"
  >
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="24">
              <el-page-header
                style="color: #333333"
                :title="$t('commonInfo.Back')"
                @back="goBack"
                :content="$t('addStore.AddStore')"
              ></el-page-header>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-main>
        <el-form
          class="search_table_info"
          ref="form"
          :rules="rules"
          :inline="true"
          :model="form"
          label-width="200px"
        >
          <el-form-item :label="$t('addStore.Country')" prop="country_id">
            <el-select
              v-model.trim="form.country_id"
              @change="get_country_info($event)"
              clearable
            >
              <el-option
                :label="item.name"
                :value="item.id"
                :key="item.id"
                v-for="item in form.country_list"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('addStore.Province')" prop="province_id">
            <el-select
              :disabled="country_focus_flag"
              v-model.trim="form.province_id"
              @change="get_province_info($event)"
              clearable
            >
              <el-option
                :label="item.name"
                :value="item.id"
                :key="item.id"
                v-for="item in form.province_list"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('addStore.City')" prop="city_id">
            <el-select
              :disabled="country_focus_flag"
              v-model.trim="form.city_id"
              @change="get_city_info($event)"
              clearable
            >
              <el-option
                :label="item.name"
                :value="item.id"
                :key="item.id"
                v-for="item in form.city_list"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('addStore.TypeOfRetailArea')"
            prop="retail_area_type_id"
          >
            <el-select
              v-model.trim="form.retail_area_type_id"
              @change="get_retail_area_type_info($event)"
              clearable
            >
              <el-option
                :label="item.name"
                :value="item.id"
                :key="item.id"
                v-for="item in form.retail_area_type_list"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('addStore.CompanyName')"
            prop="company_name"
            class="input_modle"
          >
            <el-input
              v-model.trim="form.company_name"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('addStore.area')" prop="area_size">
            <el-input
              v-model.trim="form.area_size"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('addStore.SellOutMoney')" prop="turnover">
            <el-input
              v-model.trim="form.turnover"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('addStore.SMOKSellOutMoney')"
            prop="smok_turnover"
          >
            <el-input
              v-model.trim="form.smok_turnover"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('addStore.ContactInformation')">
            <el-input
              v-model.trim="form.add_contact"
              @focus="dialogVisible = true"
              style="padding-right: 14px"
            >
              >
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('addStore.StoreAddress')" prop="address">
            <el-input
              v-model.trim="form.address"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('addStore.StoreZipCode')">
            <el-input
              v-model.trim="form.zip"
              style="padding-right: 14px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div style="float: right">
              <el-button type="primary" @click="add_store_info('form')">{{
                $t("addStore.AddNow")
              }}</el-button>
              <!-- <el-button>取消</el-button> -->
            </div>
          </el-form-item>
        </el-form>
        <!-- 添加联系人弹框 -->
        <el-dialog
          :title="$t('contactMethods.Add')"
          :visible.sync="dialogVisible"
          width="70%"
        >
          <el-form
            ref="add_contact_form"
            :model="add_contact_form"
            :inline="true"
            label-width="70px"
          >
            <ul>
              <li
                :key="index"
                v-for="(
                  item, index
                ) in add_contact_form.contact_information_list"
              >
                <el-form-item :label="$t('contactMethods.Position')">
                  <el-input v-model.trim="item.position"></el-input>
                </el-form-item>
                <el-form-item :label="$t('contactMethods.Name')">
                  <el-input v-model.trim="item.name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('contactMethods.Tel')">
                  <el-input v-model.trim="item.phone"></el-input>
                </el-form-item>
                <el-form-item :label="$t('contactMethods.Email')">
                  <el-input v-model.trim="item.e_mail"></el-input>
                </el-form-item>
                <el-button type="primary" @click="delete_contact(index)">{{
                  $t("contactMethods.Delete")
                }}</el-button>
              </li>
            </ul>
            <div style="text-align: right">
              <el-button type="primary" @click="add_contacts">{{
                $t("contactMethods.Add")
              }}</el-button>
            </div>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancel_add_contact('add_contact_form')">{{
              $t("contactMethods.Cancel")
            }}</el-button>
            <el-button
              type="primary"
              @click="add_contact_success('add_contact_form')"
              >{{ $t("contactMethods.Confirm") }}</el-button
            >
          </span>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "AddStoreInfo",
  data() {
    return {
      loading: false,
      dialogVisible: false,
      // props: { multiple: true },
      form: {
        country_list: [],
        province_list: [],
        city_list: [],
        // newest: true,
        // oldest: true,
        page_flag: 1, //切换最新和最旧数据
        country_id: "", //国家id
        province_id: "", //省份id
        city_id: "", //城市id
        retail_area_type_id: "", //零售区id
        company_name: "", //门店名称
        zip: "", //邮编
        address: "", //门店地址
        retail_area_type_list: [], //零售区类型
        area_size: "",
        turnover: "",
        smok_turnover: "",
        country: [],
        add_contact: "",
      },
      // 添加联系人列表
      add_contact_form: {
        contact_information_list: [
          {
            position: "",
            name: "",
            phone: "",
            e_mail: "",
          },
        ],
        contact_information_list_clone: [
          {
            position: "",
            name: "",
            phone: "",
            e_mail: "",
          },
        ],
        add_contact: "",
      },
      country_focus_flag: true,

      // country_options: [],
      is_shop_mall_value: "",
      is_golden_business_value: "",
      // 表单触发规则
      rules: {
        country_id: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["change"],
          },
        ],
        province_id: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["change"],
          },
        ],
        city_id: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["change"],
          },
        ],
        retail_area_type_id: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["change"],
          },
        ],
        company_name: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        area_size: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        turnover: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        smok_turnover: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        add_contact: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["blur", "change"],
          },
        ],
        address: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        position: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        name: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        e_mail: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["blur"],
          },
        ],
      },
      // 添加联系人校验
      add_contact_rules: {
        position: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        name: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["blur"],
          },
        ],
        e_mail: [
          {
            required: true,
            message: this.$t("addStore.EnterInformation"),
            trigger: ["blur"],
          },
        ],
      },
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 获取国家id
    get_country_info(e) {
      this.form.country_id = e;
      this.form.province_id = "";
      this.form.city_id = "";
      this.get_province_list(e);
    },
    // 获取省份id并获取城市列表
    get_province_info(e) {
      this.form.province_id = e;
      this.form.city_id = "";
      this.get_city_list(e);
    },
    // 获取城市id
    get_city_info(e) {
      this.form.city_id = e;
    },
    // 获取省份列表
    get_province_list(country_id) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: country_id,
      };
      this.$common
        .httpPost("/api/address/province/find/list", params)
        .then((res) => {
          _me.loading = false;
          if (res.code == "1000000") {
            this.form.province_list = res.data;
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch((err) => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            this.$router.push("sign-in");
          }
          _me.$message.error(err.message);
        });
    },
    // 获取城市列表
    get_city_list(province_id) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: province_id,
      };
      this.$common
        .httpPost("/api/address/city/find/list", params)
        .then((res) => {
          _me.loading = false;
          if (res.code == "1000000") {
            this.form.city_list = res.data;
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch((err) => {
          _me.loading = false;
          if (err.code == 1000009 || err.code == 1000007) {
            this.$router.push("sign-in");
          }
          _me.$message.error(err.message);
        });
    },
    get_retail_area_type_info(e) {
      this.form.retail_area_type_id = e;
    },
    // 添加联系人成功操作
    add_contact_success(add_contact_form) {
      // this.$refs[add_contact_form].validate((valid) => {
      //   if (valid) {
      let contact_information_list = JSON.parse(
        JSON.stringify(this.add_contact_form.contact_information_list)
      );
      for (let item of contact_information_list) {
        if (item.name !== "" || item.phone !== "" || item.position !== "") {
          this.dialogVisible = false;
          this.add_contact_form.contact_information_list_clone =
            this.$common.deepClone(
              this.add_contact_form.contact_information_list
            );

          this.form.add_contact = this.$t("addStore.Added");
        }
      }

      // }
      // });
    },

    // 添加门店信息并提交
    add_store_info(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.loading = true;
          let _me = this;
          let params = {
            // page_flag: _me.form.page_flag,
            country_id: _me.form.country_id,
            province_id: _me.form.province_id,
            city_id: _me.form.city_id,
            company_name: _me.form.company_name,
            retail_area_type_id: _me.form.retail_area_type_id,
            zip: _me.form.zip,
            address: _me.form.address,
            area_size: _me.form.area_size,
            turnover: _me.form.turnover,
            smok_turnover: _me.form.smok_turnover,
            contact_information_list: JSON.stringify(
              _me.add_contact_form.contact_information_list_clone
            ),
          };
          _me.$common
            .httpPost("/api/store/admin/add/one", params)
            .then((res) => {
              if (res.code == 1000000) {
                _me.$message.success(_me.$t("commonInfo.AddStoreSucceed"));
                this.$router.go(-1);
              } else {
                _me.$message.error(res.message);
              }
            })
            .catch((err) => {
              _me.loading = false;
              if (err.code == 1000009 || err.code == 1000007) {
                this.$router.push("sign-in");
              }
              _me.$message.error(err.message);
            });
        } else {
          return false;
        }
      });
    },
    // 获取零售区类型列表
    get_retail_area_type_list_initial() {
      this.$common
        .get_storage_list(
          "retail_area_type_list",
          "http_get",
          "/api/store/admin/retail/area/type/find/list"
        )
        .then((res) => {
          this.form.retail_area_type_list = res;
        })
        .catch((err) => {});
    },
    // 添加联系人
    add_contacts() {
      this.add_contact_form.contact_information_list.push({
        position: "",
        name: "",
        phone: "",
        e_mail: "",
      });
    },
    // 删除联系人
    delete_contact(index) {
      if (this.add_contact_form.contact_information_list.length > 1) {
        this.add_contact_form.contact_information_list.splice(index, 1);
      }
    },
    // 初始化国家列表
    get_country_list_initial() {
      this.$common
        .get_storage_list(
          "country_list",
          "http_get",
          "/api/address/country/find/list"
        )
        .then((res) => {
          this.form.country_list = res;
        })
        .catch((err) => {});
    },
    // 点击联系人遮罩层清空联系人表单数据
    //  handleClose(done) {
    //   this.$confirm('确认关闭？')
    //     .then(_ => {
    //       done();
    //     })
    //     .catch(_ => {});
    // }
    // 点击遮罩层
    handleClose() {
      // this.resetContactForm();
    },
    // 取消添加联系人
    cancel_add_contact(add_contact_form) {
      // this.resetContactForm();
      this.dialogVisible = false;
    },
    // 重置联系人表单并关闭遮罩层
    resetContactForm() {
      this.dialogVisible = false;
      let contact_information_list =
        this.add_contact_form.contact_information_list;
      contact_information_list.forEach((item, index) => {
        item.e_mail = "";
        item.name = "";
        item.phone = "";
        item.position = "";
      });
      // this.form.contact_information_list = this.model.contact_information_list;
    },
  },
  created() {},
  mounted() {
    // 初始化国家列表
    this.get_country_list_initial();
    // 初始化零售区类型列表
    this.get_retail_area_type_list_initial();
  },
  watch: {
    "form.country_id"() {
      if (this.form.country_id) {
        this.country_focus_flag = false;
      } else {
        this.country_focus_flag = true;
      }
    },
  },
};
</script>

<style scoped>
.banner-head {
  /*background-color: white;*/
  background-color: #f1f1f1;
  height: 60px;
}

.head-info {
  color: #ffffff;
}
</style>
